import { GetStoresPromoCodePayload_getStoresPromoCodePayload } from 'api/promocodes/types/GetStoresPromoCodePayload';
import { TreeDataConverter } from '../../converter/tree-data.converter';
import { TreeDataEntity } from '../../data/tree-data.entity';
import { getTicketEventOptionTitle } from '../../data/ticket-event-option-title';

export const storesPayloadMapper = (
  {
    store,
    products,
    amas,
    streams,
    ticketEvents,
  }: GetStoresPromoCodePayload_getStoresPromoCodePayload,
  withTicketEvents: boolean
): TreeDataEntity[] => {
  let result: TreeDataEntity[] = [];

  const productsData = products.map((p) => TreeDataConverter.from(p));
  if (productsData.length) {
    result = result.concat([
      {
        title: 'Merch Products',
        value: 'merch_products',
        children: productsData,
      },
    ]);
  }

  const amasData = amas.map((a) => TreeDataConverter.from(a));
  if (amasData.length) {
    result = result.concat([
      {
        title: 'AMAs',
        value: 'store_amas',
        children: amasData,
      },
    ]);
  }

  const streamsData = streams.map((s) => TreeDataConverter.from(s));
  if (streamsData.length) {
    result = result.concat([
      {
        title: 'Streams',
        value: 'store_streams',
        children: streamsData,
      },
    ]);
  }

  const ticketEventsData = (withTicketEvents ? ticketEvents : []).map(
    (ticketEvent) =>
      TreeDataConverter.from({
        id: ticketEvent.id,
        __typename: ticketEvent.__typename,
        title: getTicketEventOptionTitle(ticketEvent),
        storeId: store.id,
      })
  );
  if (ticketEventsData.length) {
    result = result.concat([
      {
        title: 'Ticket Events',
        value: 'store_ticket_events',
        children: ticketEventsData,
      },
    ]);
  }

  return result;
};
